import React from 'react';
import './Card.css';

const Card = ({ image, title, description, className = "" }) => {
  return (
    <div className={`service-card ${className}`}>
      <div className="card-body">
        <img src={image} alt={title} className="card-image" />
        <div className="card-title">{title}</div>
        <div className="card-description">{description}</div>
      </div>
    </div>
  );
};

export default Card;